// extracted by mini-css-extract-plugin
export default {"vk":"vk_vk__0NKeJ"};